<template>
  <div class="home">
    <nav class="home-btn">
      <router-link :to="{path:'/main',query:{c:'Centiare', centiare:'THOUSAND', contentID: 13}}" class="btn-1000"></router-link>
      <router-link :to="{path:'/main',query:{c:'Centiare', centiare:'FIVE_HUNDRED', contentID: 30}}" class="btn-500"></router-link>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  mounted () {

  },
  methods: {
    
  }
}
</script>

<style scoped>
.home {
  width: 10rem;
  background: url(../assets/images/index-bg.jpg) no-repeat;
  background-size: 10rem 9.708333rem;
  height: 100vh;
  overflow: hidden;
}
.home-btn {
  display: flex;
  width: 4.427083rem;
  margin: 4.0625rem auto 0;
  justify-content: space-between;
}
.home-btn a {
  display: block;
  width: 1.84375rem;
  height: 0.630208rem;
}
.btn-1000 {
  background: url(../assets/images/index-1000btn.png) no-repeat;
  background-size: 1.84375rem 0.630208rem;
}
.btn-500 {
  background: url(../assets/images/index-500btn.png) no-repeat;
  background-size: 1.84375rem 0.630208rem;
}
</style>
